import { CheckMarkCircleO } from '../Icons/CheckMarkCircleO';
import { ExclamationCircleO } from '../Icons/ExclamationCircleO';
import { InfoCircleO } from '../Icons/InfoCircleO';

export enum MessageStatus {
	Danger = 'danger',
	Warning = 'warning',
	Success = 'success',
	Info = 'info',
}

export const icon = {
	[MessageStatus.Danger]: ExclamationCircleO,
	[MessageStatus.Warning]: ExclamationCircleO,
	[MessageStatus.Success]: CheckMarkCircleO,
	[MessageStatus.Info]: InfoCircleO,
};
